import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import Immutable from "community/immutable";
import "vendor/es6-promise";
import Module from "global/sparta-module-utility";
import spartaStyleUtility from "global/sparta-style-utility";
import Utility from "community/module-utils-utility";
import Ep from "modules/home-loans/services-home-loans-module/2.2.0/js/endpoints-services-home-loans-module";
import Cx from "modules/home-loans/services-home-loans-module/2.2.0/js/constants-services-home-loans-module";
import Dp from "modules/home-loans/services-home-loans-module/2.2.0/js/dispatcher-services-home-loans-module";
import Tf from "modules/home-loans/services-home-loans-module/2.2.0/js/transform-services-home-loans-module";
import spartaTemplates from "modules/home-loans/services-home-loans-module/2.2.0/js/templates";
import "css!modules/home-loans/services-home-loans-module/2.2.0/css/services-home-loans-module.scss.css";
export default class Controllers extends Module {

  /**
   * @method constructor
   * @param {Object} options
   */
  constructor(options) {

    // Extend Module
    super(options);

  }


  /**
   * @method mortgage
   * @route
   */
  mortgageOverview(calcInput) {

    Tf.mortgageRates.bind(this)(calcInput)
      .then(payload => {
        Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch(error => {
        Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
      });

  }

  /**
   * @method refinance
   * @route
   */
  refinanceOverview(calcInput) {

    Tf.refinanceRates.bind(this)(calcInput)
      .then(payload => {
        Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch(error => {
        Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(error);
      });

  }


  adjustableRateMortgageProduct(calcInput) {

    Tf.mortgageRates.bind(this)(calcInput)
      .then(payload => {
        Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch(error => {
        Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
      });
  }

  fixedRateMortgageRatesProduct(calcInput) {

    Tf.mortgageRates.bind(this)(calcInput)
      .then(payload => {
        Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch(error => {
        Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
      });
  }

  fixedRateRefinanceProduct(zipInput) {


    Tf.refinanceRates.bind(this)(zipInput)
      .then(payload => {
        Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch(error => {
        Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(error);
      });
  }

  adjustableRateRefinanceProduct(calcInput) {

    Tf.refinanceRates.bind(this)(calcInput)
      .then(payload => {
        Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch(error => {
        Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(error);
      });
  }

  jumboLoanMortgageProduct(calcInput) {

    Tf.mortgageRates.bind(this)(calcInput)
      .then(payload => {
        Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch(error => {
        Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
      });
  }

  mortgageRates(calcInput) {

    Tf.mortgageRates.bind(this)(calcInput)
      .then(payload => {
        Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch(error => {
        Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
      });
  }

  refinanceRates(zipInput) {


    Tf.refinanceRates.bind(this)(zipInput)
      .then(payload => {
        Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch(error => {
        Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(error);
      });
  }

  homeEquityRates() {
    Tf.homeEquityRates.bind(this)()
      .then(response => Dp.HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUCCESS.bind(this)(response))
      .catch(error => Dp.HOME_LOANS_HOME_EQUITY_RATES_REQUEST_FAILURE.bind(this)(error));
  }

  assumptions() {
    Tf.assumptionsRates.bind(this)()
      .then(response => Dp.HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_SUCCESS.bind(this)(response))
      .catch(error => Dp.HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_FAILURE.bind(this)(error));
  }


  /**
   * @method generic
   */
  generic() {
    setTimeout(() => {
      Dp.HOME_LOANS_GENERIC_SUCCESS.bind(this)(null);
    }, 1000);
  }


  /**
   * @method closingCost
   * @dscr no ajax call on page load
   */
  closingCost(request) {
    const calcInput = request.data;

    Tf.closingCostCalculatorRates.bind(this)(calcInput)
      .then(payload => {
        Dp.HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch(error => {
        Dp.HOME_LOANS_CLOSING_COST_RATES_REQUEST_FAILURE.bind(this)(error);
      });


  }

  /**
   * @method
   * @params {Object} payload
   * @controller
   */
  zipcode(request) {
    const payload = request.data;

    // get zipCodeLookup rates endpoint url
    const url = spaParams.siteParams.endpoints.zipcode.url;

    // Let's create the promise for zipcode rates request
    const zipcodeRequest = Ep.zipcode(url, payload);

    // Making zip code rates request
    zipcodeRequest

      .then((payload) => {
        Dp.HOME_LOANS_ZIP_CODE_LOCATOR_SUCCESS.bind(this)(payload);
      })

      .catch((error) => {
        Dp.HOME_LOANS_ZIP_CODE_LOCATOR_FAILURE.bind(this)(error);
      });

  }

  /**
   * @method leadsCall
   * @params {Object} payload
   * @controller
   */
  leadsCall(request) {
    const payload = request.data;

    // Making leads call
    Tf.leadsCall(payload)

      .then((payload) => {
        Dp.HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch((error) => {
        Dp.HOME_LOANS_LEADS_CALL_REQUEST_FAILURE.bind(this)(error);
      });

  }

  chooseCalculatorSubmitController(request) {
    const inp = request.data;

    //get controller
    let controller = spaParams.pageParams.controller;

    //call controller passing in inputs from calculator
    this[controller](inp);
  }

  chooseZipCodeChangeSubmitController(request) {
    const inp = request.data;

    //get controller
    let controller = spaParams.pageParams.controller;

    //call controller passing in inputs from calculator
    this[controller](inp);
  }

  /**
   * @method leadsPhoneNumber
   */
  leadsPhoneNumber() {

    Tf.leadPhoneNumber.bind(this)()
      .then((payload) => {
        Dp.HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS.bind(this)(payload);
      })
      .catch((error) => {
        Dp.HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE.bind(this)(error);
      });

  }

  /**
   * @method mortgageCalculator
   * @params {Object} payload
   */
  mortgageCalculator(payload) {

    Tf.leadPhoneNumber.bind(this)().then((payload) => {
      Dp.HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS.bind(this)(payload);
    }).catch((error) => {
      Dp.HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE.bind(this)(error);
    });

    Tf.mortgageRates.bind(this)(payload).then((payload) => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch((error) => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @method mortgageCalculatorResult
   * @dscr no ajax call on page load
   */
  mortgageCalculatorResult(request) {
    const calcInput = request.data;

    Tf.mortgageCalculatorRates.bind(this)(calcInput)
      .then(payload => {
        Dp.HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch(error => {
        Dp.HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_FAILURE.bind(this)(error);
      });
  }

  /**
   * @method refinanceCalculatorResult
   * @dscr no ajax call on page load
   */
  refinanceCalculatorResult(request) {
    const calcInput = request.data;

    Tf.refinanceCalculatorRates.bind(this)(calcInput)
      .then(payload => {
        Dp.HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_SUCCESS.bind(this)(payload);
      })

      .catch(error => {
        Dp.HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_FAILURE.bind(this)(error);
      });
  }

  /**
   * @method refinanceCalculator
   * @params {Object} payload
   */
  refinanceCalculator(payload) {

    Tf.leadPhoneNumber.bind(this)().then((payload) => {
      Dp.HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS.bind(this)(payload);
    }).catch((error) => {
      Dp.HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE.bind(this)(error);
    });

    Tf.refinanceRates.bind(this)(payload).then((payload) => {
      Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch((error) => {
      Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @method init
   */
  init() {

    localStorage.clear();

    // Leads phone number
    this.leadsPhoneNumber.bind(this)();

    // Get current page
    const controller = spaParams.pageParams.controller;

    // Run current controller
    if (controller) this[controller]();

    // any controller will subscribe to a modules publish
    this.Events.sub(Cx.HOME_LOANS_ZIP_CODE_CHANGE_SUBMIT, this.chooseZipCodeChangeSubmitController.bind(this));
    this.Events.sub(Cx.HOME_LOANS_ZIP_CODE_LOCATOR_SUBMIT, this.zipcode.bind(this));
    this.Events.sub(Cx.HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT, this.leadsCall.bind(this));
    this.Events.sub(Cx.HOME_LOANS_RATES_TABLE_CALCULATOR_SUBMIT, this.chooseCalculatorSubmitController.bind(this));
    this.Events.sub(Cx.HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUBMIT, this.homeEquityRates.bind(this));
    this.Events.sub(Cx.HOME_LOANS_CLOSING_COST_CALCULATOR_SUBMIT, this.closingCost.bind(this));
    this.Events.sub(Cx.HOME_LOANS_MORTGAGE_CALCULATOR_SUBMIT, this.mortgageCalculatorResult.bind(this));
    this.Events.sub(Cx.HOME_LOANS_REFINANCE_CALCULATOR_SUBMIT, this.refinanceCalculatorResult.bind(this));

  }

}
